export default __webpack_public_path__ + "static/media/flag.ab4a47d2.svg";